import { StringKeys } from 'cng-common/models/utils'
import { IDataProviderFilter, Logic, Operator } from 'core-components/types'
import { Crud } from 'core/types/Crud'

type TKeyField<T> =
  | {
      keyField: StringKeys<T>
      caption?: StringKeys<T>
    }
  | {
      keyField?: StringKeys<T>
      caption: StringKeys<T>
    }

type TParams<T> = {
  source: Crud<T, string | number>
  value: string
} & TKeyField<T>

export async function getDropdownItemByKeyField<T>(params: TParams<T>) {
  const filter: IDataProviderFilter = {
    logic: Logic.AND,
    filters: [
      {
        field: params.keyField || params.caption!,
        operator: Operator.EQUAL,
        value: params.value,
      },
    ],
  }

  params.source.setFilter(filter)
  const items = await params.source.fetch()
  return items?.items[0]
}
